import styled from 'styled-components/macro';

import { colors } from '../../styles/vars';

export default styled.div`
  position: absolute;
  pointer-events: none;
  color: ${colors['warm-grey-two']};
`;
